<div class="preview-test-data">
  <h2 class="mat-h2">{{ fileName }}</h2>
  @if (testData && !testData.success) {
    <p>{{ testData.message }}</p>
  }

  @if (sensorFigures.length) {
    <div class="sensor-preview">
      <mat-button-toggle-group
        class="sensor-toggle-list"
        vertical
        aria-label="Sensors"
        [value]="selectedSensorNumber"
        (change)="selectSensor($event.value)">
        @for (figure of sensorFigures; track figure) {
          <mat-button-toggle
            [value]="figure.sensorNumber">
            Sensor {{ figure.sensorNumber }}
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
      @for (figure of sensorFigures; track trackBySensorNumber($index, figure)) {
        @if (figure.sensorNumber === selectedSensorNumber) {
          <div class="sensor-figure">
            <div class="sensor-figure-header">
              <h3 class="mat-h3 sensor-figure-title">{{ figure.title }}</h3>
              <button mat-stroked-button type="button" (click)="resetZoom()">Reset zoom</button>
            </div>
            <p class="sensor-figure-hint">Scroll or pinch to zoom, drag to pan.</p>
            <div class="sensor-figure-canvas">
              <canvas
                baseChart
                [data]="figure.data"
                [options]="figure.options"
                [type]="'line'">
              </canvas>
            </div>
          </div>
        }
      }
      @if (stages.length) {
        <aside class="stage-panel">
          <section class="panel-section" aria-labelledby="stage-properties-title">
            <h4 id="stage-properties-title" class="panel-section-title">Stage Properties</h4>
            <mat-form-field appearance="outline" class="panel-field">
              <mat-label>Stage</mat-label>
              <mat-select
                placeholder="Select stage"
                [value]="selectedStageNumber"
                (selectionChange)="selectStage($event.value)">
                @for (stage of stages; track stage) {
                  <mat-option [value]="stage.stageNumber">
                    {{ stage.stageNumber }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (selectedStage; as stage) {
          <ng-container *ngTemplateOutlet="fitResults; context: {
            $implicit: stageAnalysis,
            rangeLabel: 'Stage window',
            startTime: stage.startTime,
            endTime: stage.endTime,
            rangeName: 'this stage'
          }"></ng-container>
            }
          </section>
          <section class="panel-section" aria-labelledby="custom-tr-title">
            <h4 id="custom-tr-title" class="panel-section-title">Custom TR Properties</h4>
            <mat-form-field appearance="outline" class="panel-field">
              <mat-label>Custom TR Start Time</mat-label>
              <input
                matInput
                type="number"
                inputmode="numeric"
                min="0"
                step="1"
                [(ngModel)]="customStartTime"
                (keydown)="blockNonIntegerKeys($event)">
                <span matTextSuffix>s</span>
              </mat-form-field>
              <mat-form-field appearance="outline" class="panel-field">
                <mat-label>Custom TR End Time</mat-label>
                <input
                  matInput
                  type="number"
                  inputmode="numeric"
                  min="0"
                  step="1"
                  [(ngModel)]="customEndTime"
                  (keydown)="blockNonIntegerKeys($event)">
                  <span matTextSuffix>s</span>
                </mat-form-field>
                <button
                  mat-flat-button
                  color="primary"
                  type="button"
                  class="panel-button"
                  [disabled]="!canUpdateCustomTr"
                  (click)="updateCustomTr()">
                  Update Custom TR
                </button>
                @if (appliedCustomRange; as range) {
          <ng-container *ngTemplateOutlet="fitResults; context: {
            $implicit: customAnalysis,
            rangeLabel: 'Custom window',
            startTime: range.startTime,
            endTime: range.endTime,
            rangeName: 'this range'
          }"></ng-container>
                }
              </section>
            </aside>
          }
          <ng-template
            #fitResults
            let-analysis
            let-rangeLabel="rangeLabel"
            let-startTime="startTime"
            let-endTime="endTime"
            let-rangeName="rangeName">
            <dl class="stage-results">
              <div>
                <dt>{{ rangeLabel }}</dt>
                <dd>{{ startTime }}–{{ endTime }} s</dd>
              </div>
              @if (analysis && analysis.sampleCount >= minFitSamples) {
                <div>
                  <dt>Slope</dt>
                  <dd>{{ formatValue(analysis.slope, 4) }}</dd>
                </div>
                <div>
                  <dt>Initial Temperature</dt>
                  <dd>{{ formatValue(analysis.intercept, 0, '°C') }}</dd>
                </div>
                <div>
                  <dt>Fit range</dt>
                  <dd>{{ formatFitRange(analysis) }}</dd>
                </div>
                <div>
                  <dt>TR</dt>
                  <dd>{{ formatValue(analysis.tr, 0, '°C-cm/W') }}</dd>
                </div>
                <div>
                  <dt>Thermal Conductivity</dt>
                  <dd>{{ formatValue(100/analysis.tr, 2, 'W/cm-°C') }}</dd>
                </div>
                <div>
                  <dt>CD</dt>
                  <dd>{{ formatValue(analysis.cd, 0) }}</dd>
                </div>
              }
            </dl>
            @if (analysis && analysis.sampleCount < minFitSamples) {
              <p class="stage-message">
                Only {{ analysis.sampleCount }} readings in {{ rangeName }}; at least {{ minFitSamples }} are needed to fit a line.
              </p>
            }
          </ng-template>
        </div>
      }

      @if (sensorFigures.length) {
        <div class="preview-footer">
          <button mat-raised-button color="primary" type="button" (click)="openSampleInformation()">
            View Sample Information
          </button>
          <button mat-raised-button color="primary" type="button" (click)="openTemperatures()">
            Temperatures
          </button>
          <button mat-raised-button color="primary" type="button" (click)="openTestInformation()">
            View Test Information
          </button>
        </div>
      }
    </div>
